<div class="welcome-wrapper">
  <div class="container-fluid py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-7">

        <!-- ÜST KISIM / KILAVUZ BUTONU -->
        <div class="d-flex justify-content-end mb-3">
          <a href="https://akilliyoklama.ankara.edu.tr/yoklamaklavuz/" target="_blank" class="btn btn-outline-light btn-sm rounded-pill px-3 shadow-sm">
            <i class="fas fa-question-circle me-1"></i> Nasıl Kullanılır?
          </a>
        </div>

        <div class="welcome-card shadow-lg animate-slide-up">

          <!-- ICON & TITLE -->
          <div class="text-center mb-4">
            <div class="icon-circle shadow-sm mb-3">
              <i class="fas fa-mobile-alt"></i>
            </div>
            <h1 class="display-6 fw-bold text-dark">Hoş Geldiniz</h1>
            <p class="text-muted mb-0">Akıllı Yoklama Sistemi</p>
          </div>

          <!-- MOBILE WARNING -->
          <div *ngIf="!isMobile" class="alert alert-warning border-0 shadow-sm d-flex align-items-center mb-4 p-3">
            <i class="fas fa-exclamation-triangle fs-4 me-3"></i>
            <div>
              <p class="mb-0">Yoklamalara yalnızca <strong>mobil cihazlardan</strong> katılım sağlanabilir.</p>
              <small class="opacity-75">Wi-Fi ve konum doğrulaması gereklidir.</small>
            </div>
          </div>

          <!-- ANNOUNCEMENT CARD -->
          <div class="announcement-box p-4 mb-4">
            <h5 class="fw-bold mb-3 d-flex align-items-center">
              <span class="badge bg-primary me-2">Duyuru</span>
              Sisteme Geçiş Hakkında
            </h5>

            <p class="small text-secondary mb-3">
              Sevgili öğrenciler ve öğretmenler, ders katılımınız artık dijital olarak takip edilmektedir.
            </p>

            <div class="row g-2">
              <div class="col-6 col-sm-3">
                <div class="feature-item">
                  <i class="fas fa-bullseye"></i>
                  <span>Şeffaf</span>
                </div>
              </div>
              <div class="col-6 col-sm-3">
                <div class="feature-item">
                  <i class="fas fa-chart-line"></i>
                  <span>Kaliteli</span>
                </div>
              </div>
              <div class="col-6 col-sm-3">
                <div class="feature-item">
                  <i class="fas fa-laptop-code"></i>
                  <span>Dijital</span>
                </div>
              </div>
              <div class="col-6 col-sm-3">
                <div class="feature-item">
                  <i class="fas fa-balance-scale"></i>
                  <span>Eşitlik</span>
                </div>
              </div>
            </div>

            <div class="mt-3 p-2 bg-light rounded text-center">
              <small class="text-danger fw-bold">⚠️ Eski yöntemler artık geçerli değildir.</small>
            </div>
          </div>

          <!-- DASHBOARD MENU -->
          <div class="row g-3">
            <div class="col-6">
              <button class="menu-action-card" (click)="goDashboard()">
                <i class="fas fa-th-large"></i>
                <span>Dashboard</span>
              </button>
            </div>
            <div class="col-6">
              <button class="menu-action-card" (click)="goDersProgrami()">
                <i class="fas fa-book"></i>
                <span>Ders Programı</span>
              </button>
            </div>
            <div class="col-6">
              <button class="menu-action-card" (click)="goCihazYonetimi()">
                <i class="fas fa-tablet-alt"></i>
                <span>Cihazlar</span>
              </button>
            </div>
            <div class="col-6">
              <button class="menu-action-card" (click)="goGeriBildirim()">
                <i class="fas fa-comment-dots"></i>
                <span>Geri Bildirim</span>
              </button>
            </div>
          </div>

        </div>

        <!-- FOOTER GUIDE LINK -->
        <div class="text-center mt-4">
          <a href="https://akilliyoklama.ankara.edu.tr/yoklamaklavuz/" target="_blank" class="text-white-50 text-decoration-none small">
            Sistem hakkında detaylı bilgi için <u>kullanım kılavuzunu</u> inceleyin.
          </a>
        </div>

      </div>
    </div>
  </div>
</div>
